module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcBAMAAACAI8KnAAAAIVBMVEVHcEz/bhn/bSP/bxn/bx3/bhz/bxv/bxz/bhn/bxz/bhrK5bHZAAAACnRSTlMA1RWUR/e/YG83vbuAbAAAADVJREFUGNNjYKAQpCmgcLOEULiKC1GkmaRoKi2AIl21EpnHEmWAzHVdTAdJBikUSYYK8oIYAAueDP68NJMyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/NewCourseDetail/images/right.png
// module id = 1163
// module chunks = 1